<template>
  <div class="line-item">
    <figure class="line-item-image">
      <img :src="sizedImageSrc" alt="" />
    </figure>
    <div class="line-item-content">
      <a :href="url" class="line-item-content-title">
        {{ productTitle }}
      </a>
      <span v-if="variantTitle" class="line-item-content-subtitle">
        {{ variantTitle }}
      </span>
      <span class="line-item-content-price">{{ formattedPrice }}</span>
    </div>
    <div class="line-item-actions">
      <label class="line-item-actions-select-label" :for="handle">
        {{ translations.quantity }}
      </label>
      <div class="line-item-actions-select">
        <select :id="handle" v-model="currentQuantity">
          <option value="0">0</option>
          <option
            v-for="n in currentQuantity + 10"
            :key="n + productTitle"
            :value="n"
          >
            {{ n }}
          </option>
        </select>
        <svg class="icon-cheveron-down" viewbox="0 0 20 20">
          <path
            d="M9.293 12.95l0.707 0.707 5.657-5.657-1.414-1.414-4.243 4.242-4.243-4.242-1.414 1.414z"
          />
        </svg>
      </div>
      <button class="line-item-actions-remove" @click="$emit('remove')">
        {{ translations.remove }}
      </button>
    </div>
  </div>
</template>

<script>
import * as ShopifyCurrency from '@shopify/theme-currency';
import * as ShopifyImage from '@shopify/theme-images';

export default {
  props: {
    handle: {
      type: String
    },
    image: {
      type: Object
    },
    moneyFormat: {
      type: String
    },
    price: {
      type: Number
    },
    productTitle: {
      type: String
    },
    quantity: {
      type: Number
    },
    translations: {
      type: Object
    },
    url: {
      type: String
    },
    variantTitle: {
      type: String
    }
  },

  computed: {
    currentQuantity: {
      get() {
        return this.quantity;
      },
      set(newVal) {
        const value = parseInt(newVal);

        if (value === 0) {
          this.$emit('remove');
        } else {
          this.$emit('update', value);
        }
      }
    },

    formattedPrice() {
      return ShopifyCurrency.formatMoney(this.price, this.moneyFormat);
    },

    sizedImageSrc() {
      return ShopifyImage.getSizedImageUrl(this.image.src, '72x');
    }
  }
};
</script>
